import { render, staticRenderFns } from "./main.factura-venta.vue?vue&type=template&id=0b6ad8b2"
import script from "./main.factura-venta.vue?vue&type=script&lang=js"
export * from "./main.factura-venta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports